import { useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import { formatRelative } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'
import Button from '../../components/Button'
import Chat from '../../components/Chat'
import { Baloon, Container, MessageContainer } from '../../components/Chat/Messages/styles'
import { mapToComponent } from '../../components/Chat/type'
import { confirm } from '../../components/Dialog'
import Icon from '../../components/Icon'
import Modal from '../../components/Modal'
import Text from '../../components/Text'
import routes from '../../config/routes'
import { theme, ThemeProvider } from '../../config/theme'
import { RoomsContext } from '../../context/rooms-context'
import ContactAdvancedForm from '../../forms/EmailAdvanced'
import Room from '../../models/Room'
import { MessageReceived, useSocket } from '../../Socket'

interface Props {
  roomUuid: string
}

const ChatModal: React.FC<Props> = ({ roomUuid }) => {
  const [room, setRoom] = useState<Room>()
  const [icon, setIcon] = useState('notification')
  const [open, setOpen] = useState(false)
  const [showAdvanceEmail, setShowAdvanceEmail] = useState(false)
  const [title, setTitle] = useState<string>('CHAT')
  const [componentId] = useState<string>(Math.random().toString(36).substr(2, 5))
  const { token, user } = useAuth()
  const socket = useSocket()
  const { roomsState, roomsDispatch } = useContext(RoomsContext)
  const history = useHistory()
  const [notRealtiesMsg, setNotRealtiesMsg] = useState('')

  useEffect(() => {
    roomsDispatch({ type: 'set_current_component_listener', payload: componentId })
  }, [])

  useEffect(() => {
    let mounted = true
    Axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/system_settings/no-realties-message`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(({ data }) => {
      if (mounted && data.data.content) {
        setNotRealtiesMsg(data.data.content)
      }
    }).catch(() => {
    })
    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    if (room && socket) {

      socket.emit('join', {
        room: room.uuid,
      })

      socket.emit('join', {
        room: 'attendant',
      })
    }
  }, [room?.uuid])


  useEffect(() => {
    let mounted = true
    if (room && room?.attendant_id && roomsState.currentComponentListener === undefined) {
      const name = room.attendant?.name
      setTitle(`Atendido por ${name}`)
    } else {
      if (mounted)
        setTitle('CHAT')
    }
    return () => {
      mounted = false
    }
  }, [room?.attendant_id])

  useEffect(() => {
    if (room && socket) {
      socket.on('message', (data: MessageReceived) => {
        if (data.room === room.uuid && roomsState.currentComponentListener === undefined) {

          setIcon('notification-unread')
          room.unread_messages_count++
          setRoom({ ...room })
          roomsDispatch({ type: 'set_room', payload: { ...roomsState, room: room } })

          const m = data.payload
          const Component = mapToComponent[m.type]
          const type = 'received'
          const Msg = () => (
            <ThemeProvider
              theme={theme}
            >
              <Container
                onClick={() => {
                  setOpen(true)
                }}
              >
                <MessageContainer
                  style={{ maxWidth: '100%' }}
                  key={m.id}
                  type={type}
                  data-id={m.id}
                >
                  <Text
                    tag="span"
                    size="hint"
                  >
                    {m.user?.name}
                  </Text>
                  <Baloon
                    read={true}
                    isFirstSentFromUser={true}
                    isLastSentFromUser={true}
                    type={type}
                    full={m.type === 'AUDIO'}
                  >
                    <Component
                      message={m}
                      type={type}
                    />
                  </Baloon>
                  <Text
                    tag="span"
                    size="hint"
                  >
                    {formatRelative(new Date(m.created_at!), new Date(), {
                      locale: ptBR,
                    })}
                  </Text>
                </MessageContainer>
              </Container>
            </ThemeProvider>
          )
          if (!open)
            toast(<Msg />)
        }
      })

      socket.on('attendant', (data: any) => {
        const name = data.attendant?.name || '- IPTU admin'
        if (data.user?.id === user.id && roomsState.currentComponentListener === undefined) {
          if (data.attendant_id) {
            if (setRoom !== undefined) {
              const newRoom = { ...data, ...{ receiver_status: data.attendant.chat_status === 1 } }
              toast.info(`Está sendo atendido por ${name}`)
              roomsDispatch({ type: 'set_room_attended', uuid: data.uuid, payload: data.attendant })
              setRoom(newRoom)
            }
          }
        }
      })
    }
    return () => {
    }
  }, [room?.uuid, open])


  useEffect(() => {
    let mounted = true
    Axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/chat/rooms`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(({ data }) => {
      if (mounted) {
        setRoom(data.data)
        roomsDispatch({ type: 'set_room', payload: { ...roomsState, room: data.data } })
        setIcon(data.data.has_unread_messages ? 'notification-unread' : 'notification')
      }
    }).catch(() => {
      if (mounted) { toast.error('Ocorreu um erro ao carregar o chat') }
    })

    return () => {
      mounted = false
    }
  }, [roomUuid, token, open])

  if (!room) {
    return (
      <Icon
        name="dark-loader"
      />
    )
  }

  return (
    <>
      <Button
        label={(
          <>
            <Icon
              name={icon}
            />
            {room !== undefined && (<div
              style={{
                backgroundColor: 'rgba(241, 115, 127)',
                borderRadius: '100%',
                width: '18px',
                height: '18px',
                color: '#FFFFFF',
                fontFamily: 'Roboto',
                fontSize: '10px',
                fontWeight: 400,
                lineHeight: '12px',
                textAlign: 'center',
                marginTop: '-18px',
                marginLeft: '-12px',
                paddingTop: '3px',
                paddingLeft: '0px',
              }}
            >
              {roomsState.room?.unread_messages_count}
            </div>)}
          </>
        )}
        backgroundColor="transparent"
        smallPadding
        onClick={() => {
          if (user.realties_count === 0 && room.last_message === null) {
            confirm({
              title: 'Confirme',
              message: notRealtiesMsg,
              buttons: [
                {
                  label: 'Sim',
                  onClick: () => {
                    history.push(routes.realty.create.path)
                  },
                },
                {
                  label: 'Não',
                  onClick: () => {

                  },
                },
              ],
            })
          } else {
            setOpen(true)
            if (socket) {
              socket.removeListener('attendant')
              socket.removeListener('read_receipts')
            }
            setIcon('notification')
          }
        }}
      />

      <Modal
        title={title}
        open={open}
        onToggle={open => {
          setOpen(open)
          if (!open && socket) {
            setIcon('notification')
          }
          if ((!open && !room?.receiver_status) || (!open && (!room?.attendant || !room?.attendant_id))) {
            confirm({
              title: 'Confirme',
              message: 'Você quer enviar um email?',
              buttons: [
                {
                  label: 'Sim',
                  onClick: () => {
                    setShowAdvanceEmail(true)
                  },
                },
                {
                  label: 'Não',
                  onClick: () => { },
                },
              ],
            })
          }
        }}
      >
        <Chat
          room={room}
          visualizing={open}
          setTitle={setTitle}
          setRoom={setRoom}
          onMessage={() => {
            setIcon('notification-unread')
          }}
          messageClick={() => {
            setOpen(true)
          }}
          open={open}
        />
      </Modal>
      <Modal
        title="Escreva o email"
        open={showAdvanceEmail}
        onToggle={showAdvanceEmail => setShowAdvanceEmail(showAdvanceEmail)}
      >
        <div
          style={{ padding: '20px' }}
        >
          <ContactAdvancedForm
            afterSubmit={() => {
              setShowAdvanceEmail(false)
            }}
          ></ContactAdvancedForm>
        </div>
      </Modal>
    </>
  )
}

export default ChatModal
